import { FC } from 'react';
import { useTranslation } from '@packages/utils';
import {
  getNextSessionNote,
  getSessionDateTone,
} from 'components/Shared/SessionDateSort/sessionDateSort.helpers';
import {
  DateRow,
  SortNote,
} from 'components/Shared/SessionDateSort/SessionDateRow.styles';
import { TSessionDatesProps } from './SessionDates.types';
import SessionDateItem from './SessionDateItem';

const SessionDates: FC<TSessionDatesProps> = ({
  sessionDates,
  nextSessionPart,
  highlightNextSession = false,
}) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.date-sort.note',
  });

  if (sessionDates.every(({ date }) => date === null)) {
    return <> - </>;
  }

  const note = highlightNextSession
    ? getNextSessionNote(sessionDates, nextSessionPart)
    : null;

  return (
    <>
      {sessionDates.map(({ date, partType }) => (
        <DateRow
          key={partType}
          $tone={
            highlightNextSession
              ? getSessionDateTone({ date, partType }, nextSessionPart)
              : null
          }
        >
          {highlightNextSession && <span className="session-date-dot" />}
          <SessionDateItem date={date} partType={partType} />
        </DateRow>
      ))}
      {note && <SortNote $tone={note}>{t(note)}</SortNote>}
    </>
  );
};

export default SessionDates;
